import styled from 'styled-components'
import MyProjects from '../MyProjects'

const PageContainer = styled.main`
	margin: 2vh 2vw;
`

export default function MyProjectsPage() {
	return (
		<PageContainer>
			<MyProjects />
		</PageContainer>
	)
}
